 /*=========================================================================================
  File Name: state.js
  Description: Restaurant Actions
  ----------------------------------------------------------------------------------------
  Item Name: Restaurant State Module
  Author: Tan Tran
==========================================================================================*/
import queries from '../../../services/restaurant/queries.js'

export default {

    async getRestaurantProfileAction ( { commit, state, rootState }, payload) {

      let restaurantId = rootState.auth.auth.restaurantId;
      await queries.getRestaurantById(restaurantId)
      .then(
          res => {
              commit('SET_RESTAURANT_STATE', res);
         })
    },

    
}